module.exports = __webpack_public_path__ + "img/success.eb4b1b4e.svg";